import { render, staticRenderFns } from "./ppStacked.vue?vue&type=template&id=549b0ae9&"
import script from "./ppStacked.vue?vue&type=script&lang=js&"
export * from "./ppStacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports